import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";

import { DataTable } from "capitalrx-components";
import { queryString } from "capitalrx-utilities";

import { MembersTypes } from "@/types";
import { memberSearchAction } from "@/App/actions";
import { RootState } from "@/App/reducers";

import tableHeaders from "./ListTableHeaders";

import { logEvent, ANALYTIC_EVENTS } from "@/App/utils/analytics";

const FORM_NAME = "PatientSearchForm";

const ResultsTable: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { search } = useLocation();

  const { results, result_count } = useSelector((state: RootState) => state.memberSearch.memberSearchResults);
  const { MemberSearchForm } = useSelector((state: RootState) => state.form);
  const { memberSearchOptions } = useSelector((state: RootState) => state.memberSearch);

  const { userSearchForMembers } = memberSearchAction;

  let submitting = false;
  if (MemberSearchForm && MemberSearchForm.submitting) {
    submitting = MemberSearchForm.submitting;
  }

  const handleUpdate = (data: MembersTypes.MemberSearchOptions): void => {
    // check for submitted form components to add to search options
    dispatch(
      userSearchForMembers({
        data: { ...memberSearchOptions, ...data },
        formName: FORM_NAME,
      }),
    );
  };

  const handleClick = (e: { id: string }): void => {
    // preserve the existing URL parameters
    const queryParams = queryString.getQueryParams(search);

    queryParams.member_id = e.id;
    const paramsString = queryString.convertJsonToQueryString(queryParams);

    const finalPath = "/test-claim?" + paramsString;

    navigate(finalPath);

    logEvent(ANALYTIC_EVENTS.TEST_CLAIM_PATIENT.add);
  };

  const tableResultHeader = result_count + " patient(s) found:";

  let resultsTable = null;
  if (result_count) {
    resultsTable = (
      <>
        <div className="table-section-result-header">{tableResultHeader}</div>
        <DataTable
          data={results}
          headers={tableHeaders}
          onClick={handleClick}
          queryOptions={memberSearchOptions}
          isLoading={submitting}
          resultsTotalCount={result_count}
          handleUpdateRequest={handleUpdate}
          searchIsEnabled={false}
          className="search-list"
        />
      </>
    );
  }

  return resultsTable;
};

export default ResultsTable;
